import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { LogOut, ArrowLeft, Maximize2, Minimize2, PenTool, Layers, Box, FileText } from 'lucide-react';

const LOGO = '/kardif-logo.png';
// Utiliser un outil de dessin en ligne gratuit et sans pub
const ARCH_PLANNER_URL = 'https://excalidraw.com/';

function ArchPlanner() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const getBackPath = () => {
    if (user?.role === 'admin') return '/admin';
    if (user?.role === 'secretary') return '/secretary';
    return '/dashboard';
  };

  return (
    <div className={`min-h-screen bg-[#1A1A1A] flex flex-col ${isFullscreen ? 'fixed inset-0 z-50' : ''}`}>
      {/* Header */}
      <header className={`bg-black/80 backdrop-blur-lg border-b border-[#8B7355]/30 ${isFullscreen ? 'hidden' : ''}`}>
        <div className="max-w-full mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img src="/kardif-eye.png" alt="KARDIF" className="h-9 w-9 object-contain" />
              <div>
                <h1 className="text-white font-semibold flex items-center gap-2">
                  <PenTool className="h-5 w-5 text-[#8B7355]" />
                  Arch-Planner
                </h1>
                <p className="text-[#8B7355] text-xs">Plans et schémas architecturaux</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {/* Quick features info */}
              <div className="hidden md:flex items-center gap-4 mr-4">
                <div className="flex items-center gap-2 text-white/60 text-sm">
                  <Layers className="h-4 w-4" />
                  <span>Calques</span>
                </div>
                <div className="flex items-center gap-2 text-white/60 text-sm">
                  <Box className="h-4 w-4" />
                  <span>3D</span>
                </div>
                <div className="flex items-center gap-2 text-white/60 text-sm">
                  <FileText className="h-4 w-4" />
                  <span>Export</span>
                </div>
              </div>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={toggleFullscreen}
                className="border-[#8B7355]/50 text-white hover:bg-[#8B7355]/20"
              >
                {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
                <span className="ml-2 hidden sm:inline">{isFullscreen ? 'Réduire' : 'Plein écran'}</span>
              </Button>
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => nav(getBackPath())}
                className="border-[#8B7355]/50 text-white hover:bg-[#8B7355]/20"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour
              </Button>
              <Button variant="ghost" size="icon" onClick={() => logout()} className="text-white/70 hover:text-white">
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Fullscreen toggle button when in fullscreen */}
      {isFullscreen && (
        <button
          onClick={toggleFullscreen}
          className="fixed top-4 right-4 z-50 bg-black/80 text-white p-2 rounded-lg hover:bg-black transition-colors"
          title="Quitter le plein écran"
        >
          <Minimize2 className="h-5 w-5" />
        </button>
      )}

      {/* Iframe container */}
      <div className={`flex-1 ${isFullscreen ? 'h-screen' : 'h-[calc(100vh-64px)]'}`}>
        <iframe
          src={ARCH_PLANNER_URL}
          className="w-full h-full border-0"
          title="Arch-Planner"
          allow="fullscreen; clipboard-read; clipboard-write"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
        />
      </div>
    </div>
  );
}

export default ArchPlanner;
